export interface NewsArticle {
    id: number;
    title: string;
    text: string;
    media_url?: string | null;
    media_base64?: string | null;
    audience: string;
    audience_label?: string;
    link?: string | null;
    link_label?: string | null;
    push_notification: boolean | string;
    notification_title?: string;
    notification_description?: string;
    created_at: string;
    updated_at: string;
    publish_at?: string | null;
    status: string;
    created_by?: number;
    creator?: {
        id: number;
        name: string;
        email: string;
    };
    care_homes?: Array<{
        id: number;
        title: string;
    }>;
}

export interface CreateNewsPayload {
    title: string;
    text: string;
    media_base64?: string;
    audience: string;
    link?: string;
    link_label?: string;
    push_notification: boolean;
    notification_title?: string;
    notification_description?: string;
    send_to_all_care_homes: boolean;
    care_home_ids?: number[];
    publish_at?: string | null;
    status: string;
}

export interface NewsState {
    articles: NewsArticle[];
    scheduledArticles: NewsArticle[];
    publishedArticles: NewsArticle[];
    isFetching: boolean;
    isCreating: boolean;
    isUpdating: boolean;
    isPublishing: boolean;
    success: boolean;
    error: string | null;
}

export interface ResponseProps {
    data: {
        article?: NewsArticle;
        published?: NewsArticle[];
        scheduled?: NewsArticle[];
    };
    success: boolean;
}

export const AUDIENCE_CARE_HOME_USERS = 'care_home_users';
export const AUDIENCE_SELECTED_CARE_HOMES = 'selected_care_homes';

export interface PublishScheduledNewsPayload extends Partial<CreateNewsPayload> {
    id: number;
}

export interface UpdateScheduledNewsPayload extends CreateNewsPayload {
    id: number;
}
